module.exports = __webpack_public_path__ + "img/h_2.8673c9c9.jpg";